import { useAtom } from 'jotai'
import React from 'react'

import { surveyGroupFilterAtom } from '~/atoms'
import { SurveyGroupFilterInformation } from '~/components/features/SurveyGroupFilterInformation'

import { useSetSurveyGroupFilterFromLocalStorageV1 } from '../hooks/useSetSurveyGroupFilterFromLocalStorageV1'

export type HeaderContentSurveyGroupProps = {
  className?: string
  surveyGroupId: string
}

export const HeaderContentSurveyGroup = ({
  className,
  surveyGroupId,
}: HeaderContentSurveyGroupProps) => {
  const [surveyGroupFilter, setSurveyGroupFilter] = useAtom(
    surveyGroupFilterAtom,
  )

  const setSurveyGroupFilterFromLocalStorageV1 =
    useSetSurveyGroupFilterFromLocalStorageV1()

  return (
    <SurveyGroupFilterInformation
      className={className}
      filterGroups={surveyGroupFilter?.filterGroups}
      surveyGroupId={surveyGroupId}
      onChange={setSurveyGroupFilter}
      onReady={setSurveyGroupFilterFromLocalStorageV1}
    />
  )
}
